var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.33 8.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffb000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.62,5.8a3.94,3.94,0,0,1-3-1.74,3.83,3.83,0,0,1,3-1.72c1.17,0,2.18.57,2.18,1.72S14.79,5.8,13.62,5.8Zm-8.89,0c-1.14,0-2.16-.57-2.16-1.72s1-1.74,2.13-1.74a3.94,3.94,0,0,1,3,1.74A3.92,3.92,0,0,1,4.73,5.77ZM13.91,0A6.16,6.16,0,0,0,9.23,2.21,6.31,6.31,0,0,0,4.47,0C2,0,0,1.53,0,4.08s1.95,4,4.42,4A6.18,6.18,0,0,0,9.1,5.88a6.25,6.25,0,0,0,4.76,2.24c2.47,0,4.47-1.53,4.47-4.08S16.35,0,13.91,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinite);
export default __webpack_public_path__ + "static/media/infinite.44cbd81085f867fcaefa62bf32bac840.svg";
export { ForwardRef as ReactComponent };